/* ==========================================================================
  main.js
========================================================================== */
var appThemeMaster = {
  homeMap: function () {
    if ($(".offices").length && $(".svg-location").length) {
      $(".office").hide();

      var startLocation = $(".svg-location[r='30']");

      if (startLocation.length) {
        $("#" + startLocation.data("id")).show();
      }

      $(".svg-location").on("click", function () {
        $(".office").hide();
        $(".svg-location").attr("r", 15);
        $(this).attr("r", 30);
        $("#" + $(this).data("id")).show();
      });
    }
  },
  reorderEvents: function () {
    $("body").on("change", ".reorder", function () {
      window.location = $(this).find(":selected").data("action");
    });
  },
};

(function ($) {
  $(document).ready(function () {
    appThemeMaster.homeMap();
    appThemeMaster.reorderEvents();
  });

  $(window).on("resize orientationchange", function () {});

  $(window).on("scroll", function () {});

  //ie only
  if (Boolean(document.documentMode)) {
    //add svg suport for dom inserted nodes
    $(document).on("DOMNodeInserted", function (e) {
      if (
        typeof svgUseIt !== "undefined" &&
        typeof svgUseIt === "function" &&
        $(e.target).find("svg").length
      ) {
        svgUseIt();
      }
    });
  }
})(jQuery);
